export const CART_ACTION_TYPES = {
    SET_CART_ITEMS: "SET_CART_ITEMS",
    CART_DROPDOWN: "CART_DROPDOWN",
};
